<template>
    <div class="section">
        <Header class="is-uppercase has-text-weight-bold" />
        <h1 class="is-size-5 has-text-centered has-text-primary is-uppercase has-text-weight-bold" style="position:relative;">
          {{ 'Eating plan' | translate }}
          <img v-show=" ! activeSearch" @click="activeSearch = true" class="icon is-medium" style="position: absolute;right:1rem;" src="@/../static/search.svg" />
        </h1><hr>
        <ReciptSearch v-show="activeSearch" @cancel="activeSearch = false" />
        <hr v-show="activeSearch" />
        <h2 class="is-size-4 is-uppercase has-text-weight-bold">{{ 'Breakfast' | translate }}</h2><br>
        <Recipt :data="breakfast" />
        <br>
        <h2 class="is-size-4 is-uppercase has-text-weight-bold">{{ 'Lunch' | translate }}</h2><br>
        <Recipt :data="dinner" />
        <br>
        <h2 class="is-size-4 is-uppercase has-text-weight-bold">{{ 'Dinner' | translate }}</h2><br>
        <Recipt :data="supper" />
        <Footer class="is-uppercase has-text-weight-bold" />
    </div>
</template>


<script>
import axios from 'axios'
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import Header from '@/components/Header'
import Recipt from '@/components/Settings/Recipt'
import ReciptSearch from '@/components/Settings/ReciptSearch'

export default {
  name: 'Terms',
  data () {
    return {
      showMenu: false,
      activeSearch: true,
      breakfast: this.$store.getters.getRandomByTag('Breakfast'),
      dinner: this.$store.getters.getRandomByTag('Lunch'),
      supper: this.$store.getters.getRandomByTag('Dinner')
    }
  },
  async mounted() {
    if (this.$store.getters.requireSaleId && window !== undefined && window.localStorage instanceof Storage && window.localStorage.getItem('saleId') !== null) {
      const result = await axios.get(`/${ this.$store.getters.apiPrefix }/checkSale/${ window.localStorage.getItem('saleId') }`)
      if (result.data.state === 'unknown') {
        this.$router.push({ name: 'LP' })
      }
    }
  },
  components: {
    Header,
    Footer,
    Menu,
    Recipt,
    ReciptSearch
  }
}
</script>

<style>
.profile-column {
  width: 10rem;
}

.menu-icon {
  z-index: 999;
  opacity:0.5;
  position:absolute;
  top:0.5rem;
  right:0.5rem;
}
</style>


// WEBPACK FOOTER //
// src/components/Settings/EatingPlan.vue